<template>
    <div>
        <hero-bar :has-right-visible="false" menu-icon="desktop-mac"> {{this.$lang.Member.AddNew}} </hero-bar>

        <div id="app" style="padding-left: 1rem; padding-top: 1rem">
            <div class="columns">
                <!-- Member -->
                <div class="column">
                    <b style="font-size: 13px; color: #878787; padding-left: 2rem ">{{this.$lang.Member.MemberInfo}}</b>

                    <b-field style="padding-top: 1rem" horizontal :label="this.$lang.Member.Name" :type="{ 'is-danger': hasError_memberName }" :message="this.emptyWarning_memberName">
                        <b-input v-model="memberName" :maxlength="limits.firstName" style="width: 65%;"></b-input>
                    </b-field>

                    <b-field horizontal :label="this.$lang.Member.Surname" :type="{ 'is-danger': hasError_memberSurname }" :message="this.emptyWarning_memberSurname">
                        <b-input v-model="memberSurname" :maxlength="limits.lastName" style="width: 65%;"></b-input>
                    </b-field>

                    <b-field horizontal :label="this.$lang.Member.Email" :type="{ 'is-danger': hasError_email }" :message="this.emptyWarning_email">
                        <b-input v-model="email" type="text" :maxlength="limits.emailAddress" style="width: 65%;"></b-input>
                    </b-field>

                    <b-field horizontal :label="this.$lang.Member.Password" :type="{ 'is-danger': hasError_password }" :message="this.emptyWarning_password">
                        <b-input v-model="password" type="password" @input="password_check" password-reveal style="width: 65%;"></b-input>
                    </b-field>
                    <b-field v-if="isSaveBtnClicked" style="padding-left:8.5rem">
                        <p class="frmValidation" :class="{'frmValidation--passed' : password.length > 7}"><i class="frmIcon mdi" :class="password.length > 7 ? 'mdi-check-circle' : 'mdi-close-circle'"></i> {{this.$lang.Password.Password_1}}</p>
                    </b-field>
                    <b-field v-if="isSaveBtnClicked" style="padding-left:8.5rem">
                        <p class="frmValidation" :class="{'frmValidation--passed' :has_uppercase }"><i class="frmIcon mdi" :class="has_uppercase ? 'mdi-check-circle' : 'mdi-close-circle'"></i> {{this.$lang.Password.Password_2}}</p>
                    </b-field>
                    <b-field v-if="isSaveBtnClicked" style="padding-left:8.5rem">
                        <p class="frmValidation" :class="{'frmValidation--passed' :has_lowercase }"><i class="frmIcon mdi" :class="has_lowercase ? 'mdi-check-circle' : 'mdi-close-circle'"></i> {{this.$lang.Password.Password_3}}</p>
                    </b-field>
                    <b-field v-if="isSaveBtnClicked" style="padding-left:8.5rem">
                        <p class="frmValidation" :class="{'frmValidation--passed' : has_number }"><i class="frmIcon mdi" :class="has_number ? 'mdi-check-circle' : 'mdi-close-circle'"></i> {{this.$lang.Password.Password_4}}</p>
                    </b-field>
                    <b-field v-if="isSaveBtnClicked" style="padding-left:8.5rem">
                        <p class="frmValidation" :class="{'frmValidation--passed' : has_special }"><i class="frmIcon mdi" :class="has_special ? 'mdi-check-circle' : 'mdi-close-circle'"></i> {{this.$lang.Password.Password_5}}</p>
                    </b-field>

                    <b-field style="padding-top: 1rem" horizontal :label="this.$lang.Member.Password_2" :type="{ 'is-danger': hasError_password_2 }" :message="this.emptyWarning_password_2">
                        <b-input v-model="password_2" type="password" password-reveal style="width: 65%;"></b-input>
                    </b-field>
                </div>

                <!-- Company -->
                <div class="column">
                    <b style="font-size: 13px; color: #878787; padding-left: 0.5rem">{{this.$lang.Member.CompanyInfo}}</b>

                    <b-field style="padding-top: 1rem" horizontal :label="this.$lang.Member.Title" :type="{ 'is-danger': hasError_title }" :message="this.emptyWarning_title">
                        <b-input v-model="title" :maxlength="limits.tradeName" style="width: 52%; padding-top: 0.5rem"></b-input>
                    </b-field>

                    <!-- TR: country is fixed to Türkiye. EN: the user picks one. -->
                    <b-field horizontal :label="this.$lang.Member.Country" :type="{ 'is-danger': hasError_country }" :message="this.emptyWarning_country">
                        <b-input v-if="isTr" :value="country" disabled style="width: 52%;"></b-input>
                        <b-select v-else v-model="country" @input="onCountryChanged()">
                            <option v-for="(option, index) in countryOptions" :value="option.name" :key="index">
                                {{ countryLabel(option) }}
                            </option>
                        </b-select>
                    </b-field>

                    <!-- The CRM requires a city only when the country is Türkiye, so show it then. -->
                    <b-field horizontal v-if="isCityRequired" :label="this.$lang.Member.City" :type="{ 'is-danger': hasError_city }" :message="this.emptyWarning_city">
                        <b-select v-model="city" @input="setCityId()">
                            <option v-for="option in cityNameList" :value="option" :key="option">
                                {{ option }}
                            </option>
                        </b-select>
                    </b-field>

                    <!--
                        intl-tel-input handles the flag, the dial code, the mask and the
                        validity check. It emits the number already in E.164 form, which is
                        what the CRM validator wants.
                    -->
                    <b-field horizontal :label="this.$lang.Member.Phone">
                        <div class="field" style="width: 70%;">
                            <phone-input ref="phoneInput"
                                         v-model="phone"
                                         :locale="isTr ? 'tr' : 'en'"
                                         required />
                        </div>
                    </b-field>
                </div>

                <!-- Consent. Shown in both languages; the texts are different documents, not translations. -->
                <div class="column">
                    <b-field v-if="this.$lang.Member.Warning01">
                        {{ this.$lang.Member.Warning01 }}
                    </b-field>

                    <b-field class="block" :type="{ 'is-danger': hasError_isAccepted_1 }" :message="this.emptyWarning_isAccepted_1">
                        <b-checkbox v-model="isAccepted_1">
                            <span v-html="this.$lang.Member.Warning02"></span>
                        </b-checkbox>
                    </b-field>

                    <!--
                        Communication permission (IYS). Independent of the KVKK consent
                        above: optional by design, and the only thing that sets AllowComm.
                    -->
                    <b-field class="block">
                        <b-checkbox v-model="isAccepted_2">
                            <span v-html="this.$lang.Member.Warning03"></span>
                        </b-checkbox>
                    </b-field>

                    <!--
                        Cloudflare Turnstile. The token it produces is checked by the API
                        before the member is written, so removing this from the page does
                        not get a registration through.
                    -->
                    <b-field class="block">
                        <turnstile-widget ref="turnstile"
                                          v-model="turnstileToken"
                                          :locale="isTr ? 'tr' : 'en'"
                                          @unavailable="turnstileToken = ''" />
                    </b-field>

                    <b-field>
                        <p class="control">
                            <b-button class="button is-primary" :loading="isSaving" @click="submit()">{{this.$lang.Member.SaveBtn}}</b-button>
                        </p>
                    </b-field>
                </div>

                <b-modal v-model="showKvkkModal" :can-cancel="['escape', 'x']" has-modal-card>
                    <div class="modal-card">
                        <header class="modal-card-head">
                            <p class="modal-card-title">{{ this.$lang.Member.KvkkModalTitle }}</p>
                        </header>
                        <section class="modal-card-body">
                            <p v-html="this.$lang.Member.KvkkModalBody"></p>
                        </section>
                        <footer class="modal-card-foot">
                            <button class="button is-primary" @click="showKvkkModal = false">{{ this.$lang.Member.KvkkModalClose }}</button>
                        </footer>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import PhoneInput from '@/components/PhoneInput.vue';
    import TurnstileWidget from '@/components/TurnstileWidget.vue';
    import {
        COMM_LANGUAGE_TR_ID,
        COMM_LANGUAGE_EN_ID,
        COUNTRY_TURKIYE_ID,
        COMM_LANGUAGE_TR_NAME,
        COMM_LANGUAGE_EN_NAME,
        COUNTRY_TURKIYE_NAME,
        isValidEmail,
        LIMITS
    } from '@/constants/registration';

    export default {
        name: 'AddMember',
        components: { PhoneInput, TurnstileWidget },
        data() {
            return {
                isSaveBtnClicked: false,
                isSaving: false,
                showKvkkModal: false,

                memberName: '',
                memberSurname: '',
                email: '',
                password: '',
                password_2: '',
                has_number: false,
                has_lowercase: false,
                has_uppercase: false,
                has_special: false,

                title: '',
                country: '',
                countryId: '',
                countryList: [],
                city: '',
                cityId: '',
                cityList: [],
                cityNameList: [],
                phone: '',

                langList: [],
                langNameList: [],
                langId: '',
                commLanguage: '',

                isAccepted_1: false,
                isAccepted_2: false,

                turnstileToken: '',

                limits: LIMITS,

                hasError_memberName: false,
                emptyWarning_memberName: '',
                hasError_memberSurname: false,
                emptyWarning_memberSurname: '',
                hasError_email: false,
                emptyWarning_email: '',
                hasError_password: false,
                emptyWarning_password: '',
                hasError_password_2: false,
                emptyWarning_password_2: '',
                hasError_title: false,
                emptyWarning_title: '',
                hasError_country: false,
                emptyWarning_country: '',
                hasError_city: false,
                emptyWarning_city: '',
                hasError_isAccepted_1: false,
                emptyWarning_isAccepted_1: ''
            };
        },
        computed: {
            /** The Turkish form and the English form are different documents, not translations. */
            isTr() {
                return this.$lang.Format.Lang == 'tr-TR';
            },

            /**
             * The CRM makes cityId conditional on the country being Türkiye
             * (Conditional, Country SapCode=TR), so the field follows the country rather
             * than the language of the form.
             */
            isCityRequired() {
                return this.country == COUNTRY_TURKIYE_NAME;
            },

            /**
             * The English form lists countries by their English names, but the option value
             * stays the Turkish name - that is what Members.Country holds, so a member who
             * registers in English still finds their country selected when they later open
             * the Turkish profile.
             *
             * Sorted by whatever is displayed: the list arrives in Turkish order, which
             * would scatter the English labels.
             */
            countryOptions() {
                var self = this;
                return this.countryList.slice().sort(function (a, b) {
                    return self.countryLabel(a).localeCompare(
                        self.countryLabel(b), self.isTr ? 'tr' : 'en');
                });
            },
        },
        created() {
            this.$store.state.isFooterFixed = false;
            this.getCountryList();
            this.getLangList();
        },
        updated() {
            // Warning02 is injected with v-html, so the modal link has to be wired up by hand.
            var link = document.querySelector('.kvkk-link');
            if (link && !link.dataset.bound) {
                link.dataset.bound = '1';
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.showKvkkModal = true;
                });
            }
        },
        methods: {
            /* ---------- reference lists ---------- */

            getCountryList() {
                this.countryList = [];
                api.members.getCountries().then((res) => {
                    if (res == null || res.isError) {
                        return;
                    }
                    this.countryList = res.data;

                    if (this.isTr) {
                        this.country = COUNTRY_TURKIYE_NAME;
                        this.resolveCountryId();
                        this.getCityList();
                    }
                });
            },

            resolveCountryId() {
                var found = this.findCountry(this.country);
                this.countryId = found ? found.id : (this.isTr ? COUNTRY_TURKIYE_ID : '');
            },

            findCountry(name) {
                for (var i = 0; i < this.countryList.length; i++) {
                    if (this.countryList[i].name === name) {
                        return this.countryList[i];
                    }
                }
                return null;
            },

            /** Falls back to the Turkish name for a country the CRM has no English name for. */
            countryLabel(option) {
                return (!this.isTr && option.englishName) ? option.englishName : option.name;
            },


            onCountryChanged() {
                this.resolveCountryId();
                this.city = '';
                this.cityId = '';
                this.cityNameList = [];
                this.cityList = [];
                if (this.isCityRequired) {
                    this.getCityList();
                }
                this.syncPhoneCountry();
            },

            /**
             * The dial code follows the country the visitor picked. Asked for by the
             * customer: choosing Germany and then being offered a +1 placeholder reads as
             * the form ignoring the answer it was just given.
             *
             * Digits already typed are kept. A country with no dial code - the CRM returns
             * a few, such as Antarctica - leaves the field untouched.
             */
            syncPhoneCountry() {
                var option = this.findCountry(this.country);
                if (option && option.sapCode && this.$refs.phoneInput) {
                    this.$refs.phoneInput.setCountry(option.sapCode);
                }
            },

            getCityList() {
                this.cityNameList = [];
                this.cityList = [];
                if (!this.countryId) {
                    return;
                }
                api.members.getCities(this.countryId).then((res) => {
                    if (res == null || res.isError) {
                        return;
                    }
                    res.data.forEach((e) => {
                        this.cityNameList.push(e.name);
                        this.cityList.push(e);
                    });
                    this.setCityId();
                });
            },

            setCityId() {
                if (this.city != '' && this.city != null) {
                    var i = this.cityNameList.indexOf(this.city);
                    this.cityId = i === -1 ? '' : this.cityList[i].id;
                }
            },

            /**
             * The communication language is not on the form. It is decided by which form the
             * user is looking at: Turkish form -> Türkçe, English form -> İngilizce.
             */
            getLangList() {
                this.commLanguage = this.isTr ? COMM_LANGUAGE_TR_NAME : COMM_LANGUAGE_EN_NAME;
                this.langId = this.isTr ? COMM_LANGUAGE_TR_ID : COMM_LANGUAGE_EN_ID;

                api.members.getCommLanguages().then((res) => {
                    if (res == null || res.isError) {
                        return; // keep the constant fallback
                    }
                    this.langNameList = [];
                    this.langList = [];
                    res.data.forEach((e) => {
                        this.langNameList.push(e.name);
                        this.langList.push(e);
                    });
                    var i = this.langNameList.indexOf(this.commLanguage);
                    if (i !== -1) {
                        this.langId = this.langList[i].id;
                    }
                });
            },

            /* ---------- validation ---------- */

            password_check() {
                this.has_number = /\d/.test(this.password);
                this.has_lowercase = /[a-z]/.test(this.password);
                this.has_uppercase = /[A-Z]/.test(this.password);
                this.has_special = /[!@#$%^&*()+=._-]/.test(this.password);
            },

            clearErrors() {
                this.hasError_memberName = false; this.emptyWarning_memberName = '';
                this.hasError_memberSurname = false; this.emptyWarning_memberSurname = '';
                this.hasError_email = false; this.emptyWarning_email = '';
                this.hasError_password = false; this.emptyWarning_password = '';
                this.hasError_password_2 = false; this.emptyWarning_password_2 = '';
                this.hasError_title = false; this.emptyWarning_title = '';
                this.hasError_country = false; this.emptyWarning_country = '';
                this.hasError_city = false; this.emptyWarning_city = '';
                this.hasError_isAccepted_1 = false; this.emptyWarning_isAccepted_1 = '';
            },

            fail(field, message) {
                this['hasError_' + field] = true;
                this['emptyWarning_' + field] = message;
            },

            /** Collects every problem at once rather than stopping at the first. */
            validate() {
                this.clearErrors();
                var empty = this.$lang.Menus.EmptyWarning;
                var ok = true;

                if (this.memberName.trim() == '') { this.fail('memberName', empty); ok = false; }
                if (this.memberSurname.trim() == '') { this.fail('memberSurname', empty); ok = false; }

                if (this.email.trim() == '') {
                    this.fail('email', empty); ok = false;
                } else if (!isValidEmail(this.email.trim())) {
                    this.fail('email', this.$lang.Member.EmailError); ok = false;
                }

                if (!this.isPasswordStrong()) {
                    this.fail('password', empty); ok = false;
                }
                if (this.password_2 == '' || this.password_2 != this.password) {
                    this.fail('password_2', empty); ok = false;
                }

                if (this.title.trim() == '') { this.fail('title', empty); ok = false; }

                if (this.country == '' || this.countryId == '') {
                    this.fail('country', empty); ok = false;
                }
                if (this.isCityRequired && (this.city == '' || this.cityId == '')) {
                    this.fail('city', empty); ok = false;
                }

                // The component shows its own message, so nothing to set here.
                if (!this.validatePhone()) { ok = false; }

                // Only the KVKK consent is mandatory. The communication permission below
                // is an opt-in and must not block registration.
                if (!this.isAccepted_1) {
                    this.fail('isAccepted_1', empty); ok = false;
                }

                // The component shows its own message, like PhoneInput.
                if (!this.validateTurnstile()) { ok = false; }

                return ok;
            },

            isPasswordStrong() {
                return this.password.length > 7 &&
                    this.has_number && this.has_lowercase && this.has_uppercase && this.has_special;
            },

            validatePhone() {
                var input = this.$refs.phoneInput;
                return input ? input.validate() : false;
            },

            validateTurnstile() {
                if (this.turnstileToken) {
                    return true;
                }
                var widget = this.$refs.turnstile;
                if (widget) {
                    widget.showRequired(this.$lang.Member.CaptchaError);
                }
                return false;
            },

            /**
             * A Turnstile token is single-use: once the API has posted it to Cloudflare it
             * cannot be sent again. Any failed attempt therefore needs a fresh one.
             */
            resetTurnstile() {
                var widget = this.$refs.turnstile;
                if (widget) {
                    widget.reset();
                }
                this.turnstileToken = '';
            },

            /**
             * Every step of the save chain used to return in silence when the API said no,
             * so a visitor got no record and no message - which is exactly what was
             * reported. Anything that is not a field-level problem says so here.
             */
            failSaving() {
                this.isSaving = false;
                this.$buefy.toast.open({
                    message: this.$lang.Member.SaveFailed,
                    type: 'is-danger',
                    duration: 6000
                });
            },

            /* ---------- submit ---------- */

            submit() {
                this.isSaveBtnClicked = true;
                if (this.isSaving || !this.validate()) {
                    return;
                }

                var member = {
                    CrmMemberId: null,
                    Name: this.memberName.trim(),
                    SurName: this.memberSurname.trim(),
                    Email: this.email.trim(),
                    Passwordd: this.password,
                    Title: this.title.trim(),
                    Country: this.country,
                    CountryId: this.countryId,
                    City: this.city,
                    CityId: this.cityId,
                    Town: '',
                    Phone: this.phone,
                    PhoneBusiness: '',
                    CommLanguage: this.commLanguage,
                    CommLangId: this.langId,
                    AllowComm: this.isAccepted_2
                };

                this.isSaving = true;
                api.members.encryptMember(member).then((res) => {
                    if (res == null || res.isError) {
                        this.failSaving();
                        return;
                    }
                    var encrypted = res.data;
                    this.checkUniqueThenSave(encrypted);
                });
            },

            checkUniqueThenSave(encrypted) {
                api.members.IsMailUnique(encrypted.Email).then((mailRes) => {
                    if (mailRes == null || mailRes.isError) { this.failSaving(); return; }
                    if (!mailRes.data) {
                        this.isSaving = false;
                        this.fail('email', this.$lang.Member.EmailError);
                        return;
                    }

                    api.members.IsPhoneNumberUnique(encrypted.Phone).then((phoneRes) => {
                        if (phoneRes == null || phoneRes.isError) { this.failSaving(); return; }
                        if (!phoneRes.data) {
                            this.isSaving = false;
                            this.fail('phone', this.$lang.Member.MobilePhone);
                            return;
                        }

                        this.saveMember(encrypted);
                    });
                });
            },

            saveMember(encrypted) {
                api.members.addNewMember(encrypted, this.turnstileToken).then((res) => {
                    if (res == null || res.isError) {
                        // The API consumed the token whether it accepted it or not.
                        this.resetTurnstile();
                        if (res != null && res.status == 403) {
                            this.isSaving = false;
                            this.$refs.turnstile.showRequired(this.$lang.Member.CaptchaError);
                        } else {
                            this.failSaving();
                        }
                        return;
                    }

                    this.$buefy.toast.open(this.$lang.Member.MemberAdded);

                    // A visitor who registered part-way through a calculation keeps their work:
                    // sign them in and move the draft project onto the new member.
                    if (this.$store.state.canResultOpen) {
                        this.signInAndClaimDraft(encrypted);
                    } else {
                        this.isSaving = false;
                        router.push('/LoginMember');
                    }
                });
            },

            signInAndClaimDraft(encrypted) {
                api.members.getMember(encrypted.Email, encrypted.Passwordd).then((res) => {
                    if (res == null || res.isError || res.data == null) {
                        // Registered, but we could not sign them in - let them log in by hand.
                        this.isSaving = false;
                        router.push('/LoginMember');
                        return;
                    }

                    var member = res.data;
                    this.$store.commit('user', member);
                    this.$store.state.memberId = member.Id + '';
                    this.$store.state.isAdmin = member.IsAdmin;

                    api.panels.updateProjectMemberId(this.$store.state.projectId, member.Id).then(() => {
                        this.updateAcceptLog();
                        this.isSaving = false;
                        router.push('/results');
                    });
                });
            },

            updateAcceptLog() {
                if (this.$store.state.memberId == 'TestMember') {
                    return;
                }
                api.panels.updateAcceptLog({
                    MemberId: this.$store.state.memberId,
                    ProjectId: this.$store.state.projectId,
                    OldProjectId: this.$store.state.projectId
                });
            }
        }
    };
</script>
